"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Airror = void 0;
class Airror extends Error {
    constructor({ message, type, extra, statusCode }, extraOverride) {
        super(message);
        this.type = type;
        this.extra = (extraOverride || extra);
        this.statusCode = statusCode;
        Object.setPrototypeOf(this, Airror.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
    get json() {
        const { type, extra, message, statusCode } = this;
        return { type, extra, message, statusCode };
    }
    static assertHandled(airror) { }
}
exports.Airror = Airror;
//# sourceMappingURL=airror.js.map